





























































import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import ConfigsService from "@/services/api/configs.service";
import { BaseSideComponent } from "@/components/structure/MixinsSideComponent";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import { FeedbackService } from "@/services/api/feedback.service";
import { AppGroupService } from "@/services/api/appgroup.service";
import { CreateFeedbackCommand, GetAppGroupsDtosQuery } from "@/server/app.commands";
import {
  AppGroupDto,
  FeedbackTypeDto,
  LanguageDto,
  UserDto,
} from "@/server/app.dtos";
import { UsersService } from "@/services/api/users.service";
import { GetUsersDtosIncludeOptions, GetUsersDtosQuery } from "@/server/app.queries";

@Component
export default class CreateFeedbackSideMenuComponent extends BaseSideComponent {
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  configsService: ConfigsService = new ConfigsService();
  feedbacksService: FeedbackService = new FeedbackService();
  usersService: UsersService = new UsersService();
  appGroupService: AppGroupService = new AppGroupService();
  instance: CreateFeedbackCommand = new CreateFeedbackCommand();
  feedbackTypes: FeedbackTypeDto[] | null = null;
  users: UserDto[] | null = null;
  appGroups: AppGroupDto[] | null = null;
  feedbackType: number | null = null;
  isLoading: boolean = false;
  isValid: boolean = false;

  async onCreateFeedback() {
    if (this.isLoading || !this.isValid) return;
    this.isLoading = true;
    await this.feedbacksService
      .Create(this.instance)
      .then((id: number) => {
        NotificationServiceBus.showSuccessMessage(
          "Sucesso",
          "Operação efetuada com sucessso"
        );
        this.$router.push(`/feedback/${id}`);
      })
      .catch((error: any) => NotificationServiceBus.showError(error))
      .finally(() => (this.isLoading = false));
  }

  selectFeedbackType(idFeedbackType:number){
    this.feedbackType = idFeedbackType;
    this.instance.idFeedbackType = idFeedbackType;
  }

  async created() {
    const query: string = "IdLanguage=" + this.currentLanguage.idLanguage;

    // Load Feedback Types
    await this.configsService.Load("api/feedbackTypes", query).then(result => {
      this.feedbackTypes = result;
    });
    
    // Load Users
    const request = new GetUsersDtosQuery();
    request.init(this.$route.query);
    request.includes = new GetUsersDtosIncludeOptions();
    await this.usersService.GetList(request).then(result => {
      this.users = result.data;
    });

    // Load AppGroups
    const appGroupsRequest = new GetAppGroupsDtosQuery();
    appGroupsRequest.init(this.$route.query);

    await this.appGroupService.GetList(appGroupsRequest).then(result => {
      this.appGroups = result;      
    });
  }

}
